import { Intent } from '@blueprintjs/core'
import { CSSProperties } from 'react'
import { rgbaForIntent } from '../../../../../utils/color'

interface TemplateStyles {
  requiredLabel: CSSProperties
}

export const templateStyles: TemplateStyles = {
  requiredLabel: { color: rgbaForIntent(Intent.DANGER, 0.75) }
}
